import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { PopoverContent } from "@similarweb/ui-components";

export type ContentTheme = "dark" | "light";

export const StyledPopoverContent = styled(PopoverContent)<{ $theme: ContentTheme }>`
    ${({ $theme }) => {
        switch ($theme) {
            case "light":
                return css`
                    color: ${colorsPalettes.black[0]};
                    background-color: ${colorsPalettes.carbon[0]};
                `;

            case "dark":
            default:
                return css`
                    color: ${colorsPalettes.carbon[0]};
                    background-color: ${colorsPalettes.carbon[500]};
                `;
        }
    }};

    *:focus {
        outline: none;
    }
`;
